import { merchantPayoutTabValueMapping } from 'consts/merchantPayouts';
import { TabManager } from 'util/tab';
import { useTypedSelector } from 'hooks';
import useMerchantPayoutActions from "features/merchantPayouts/useActions";
import { selectIsMerchantPayoutLoading, selectMerchantPayoutsActiveTab } from 'features/merchantPayouts/selectors';

export default function useMerchantPayouts() {
    const activeTab = useTypedSelector(selectMerchantPayoutsActiveTab);
    const isMerchantPayoutsLoading = useTypedSelector(selectIsMerchantPayoutLoading);

    const { onChangeTab } = useMerchantPayoutActions();

    const getTabValue = () =>
        TabManager.getTabValue(merchantPayoutTabValueMapping, activeTab);

    return {
        isMerchantPayoutsLoading,
        getTabValue,
        onChangeTab
    };
};
